(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snackura-discovery"] && !Shopify.designMode) return;
  try {
    
  const snackuraMotionControllers = new WeakMap();
  function prepareSnackuraMotion(root) {
    const sections = root.matches?.('.sn-discovery') ? [root] : root.querySelectorAll('.sn-discovery');
    sections.forEach((section) => {
      if (snackuraMotionControllers.has(section)) return;
      const control = section.querySelector('.sn-motion-control');
      const photo = section.querySelector('.sn-discovery-photo');
      if (!control || !photo || !('IntersectionObserver' in window)) return;
      const abort = new AbortController();
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const desktop = window.matchMedia('(min-width: 900px)');
      const signal = abort.signal;
      let userPaused = false;
      let enabled = false;
      let photoVisible = false;
      let frame = 0;
      const updateDepth = () => {
        frame = 0;
        if (!enabled || !photoVisible || !desktop.matches || document.hidden) return;
        const rect = photo.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
        photo.style.setProperty('--sn-depth-y', `${((.5 - progress) * 24).toFixed(2)}px`);
        photo.style.setProperty('--sn-depth-scale', (.985 + progress * .03).toFixed(4));
      };
      const requestDepth = () => {
        if (!frame && enabled && photoVisible && desktop.matches && !document.hidden) frame = requestAnimationFrame(updateDepth);
      };
      const sync = () => {
        enabled = !reduced.matches && !userPaused;
        section.dataset.motion = enabled ? 'on' : 'off';
        section.dataset.tabActive = String(!document.hidden);
        control.disabled = reduced.matches;
        control.setAttribute('aria-pressed', String(enabled));
        control.querySelector('span').textContent = reduced.matches ? control.dataset.reducedLabel : enabled ? control.dataset.pauseLabel : control.dataset.playLabel;
        if (!enabled || !desktop.matches || document.hidden) {
          cancelAnimationFrame(frame); frame = 0;
          photo.style.removeProperty('--sn-depth-y');
          photo.style.removeProperty('--sn-depth-scale');
        } else requestDepth();
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const element = entry.target;
          if (element === photo) { photoVisible = entry.isIntersecting; requestDepth(); return; }
          element.classList.toggle('sn-in-view', entry.isIntersecting);
          if (entry.isIntersecting && enabled && !element.dataset.motionSeen) element.classList.add('sn-motion-enter');
        });
      }, { threshold: .2 });
      observer.observe(photo);
      section.querySelectorAll('.sn-category,.sn-map-heading,.sn-mochi').forEach((element) => {
        observer.observe(element);
        element.addEventListener('animationend', (event) => {
          if (!['sn-icon-arrive','sn-word-arrive','sn-mochi-greeting'].includes(event.animationName)) return;
          element.dataset.motionSeen = 'true';
          element.classList.remove('sn-motion-enter');
          observer.unobserve(element);
        }, { signal });
      });
      control.hidden = false;
      control.addEventListener('click', () => { userPaused = !userPaused; sync(); }, { signal });
      reduced.addEventListener('change', sync, { signal });
      desktop.addEventListener('change', sync, { signal });
      window.addEventListener('scroll', requestDepth, { passive: true, signal });
      window.addEventListener('resize', requestDepth, { passive: true, signal });
      document.addEventListener('visibilitychange', sync, { signal });
      sync();
      snackuraMotionControllers.set(section, () => { observer.disconnect(); abort.abort(); cancelAnimationFrame(frame); });
    });
  }
  prepareSnackuraMotion(document);
  document.addEventListener('shopify:section:load', (event) => prepareSnackuraMotion(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.sn-discovery').forEach((section) => {
      snackuraMotionControllers.get(section)?.();
      snackuraMotionControllers.delete(section);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
